
import { contentWidth } from '@lib/theme';

// Viewport dimension
export const width = contentWidth * 0.85;